<template>
  <div id="spookynook-activenet-calendar-widget" :class="{ 'ios-mobile': isIosMobile }">
    <CalendarFiltersBar
      v-if="initialDataLoaded"
      :filters-options="filtersOptions"
      :initial-filters="initialFilters"
      :default-filters="defaultFilters"
      :page="page"
      @filters-changed="FilterChanged"
    />
    <CalendarResults
      v-if="sortOptions.length && sort"
      :results-number="count"
      :sort-options="sortOptions"
      :initial-sort="sort"
      :results="results"
      :show-preloader="showPreloader"
      :no-result-url="noResultUrl"
      @sort-changed="ResultsSortChange"
    />
    <AppPagination :total-pages="total_pages" :current-page="page" @page-change="PageChanged" />
  </div>
</template>

<script>
import { getCalendarData, getFilteredCalendarData } from './api/filter.api.ts'
import CalendarFiltersBar from './components/CalendarFiltersBar'
import CalendarResults from './components/CalendarResults'
import AppPagination from './components/AppPagination'

export default {
  components: {
    CalendarFiltersBar,
    CalendarResults,
    AppPagination
  },
  data() {
    return {
      filtersOptions: {
        location: [],
        category: [],
        activity: [],
        sport: [],
        gender: [],
        age: []
      },
      initialFilters: {
        startDate: '',
        location: [],
        category: [],
        activity: [],
        sport: [],
        gender: [],
        age: [],
        search: ''
      },
      defaultFilters: {
        startDate: '',
        location: [],
        category: [],
        activity: [],
        sport: [],
        gender: [],
        age: [],
        search: ''
      },
      initialDataLoaded: false,
      showPreloader: true,
      sort: '',
      results: [],
      sortOptions: [],
      baseUrl: this.$root.$data.baseUrl + '/api/calendar',
      filtersQuery: {},
      count: 0,
      page: 0,
      total_pages: 0,
      noResultUrl: 'https://www.spookynooksports.com/manheim/email-sign-up'
    }
  },
  created() {
    this.GetInitData()
  },
  methods: {
    async GetInitData() {
      // Query for program specific
      const programSpecificQuery = {
        location: this.$root.$data?.location,
        category: this.$root.$data?.category,
        activity: this.$root.$data?.activity,
        sport: this.$root.$data?.sport,
        gender: this.$root.$data?.gender,
        age: this.$root.$data?.age,
        organization: this.$root.$data?.organization
      }

      const [error, response] = await getCalendarData(this.baseUrl, programSpecificQuery)
      const facets = response.facets

      if (error) console.log(error)
      else {
        this.filtersOptions.location = facets.locations
        this.filtersOptions.category = facets.category
        this.filtersOptions.activity = facets.activity
        this.filtersOptions.sport = facets.sport
        this.filtersOptions.gender = facets.gender
        this.filtersOptions.age = facets.age

        this.count = response.count
        this.results = response.table
        this.sortOptions = response.sort_options
        this.sort = response.sort_options[4]
        this.total_pages = response.pager_info.total_pages
        this.showPreloader = false

        this.ParseQuery()
        this.ParseProgramSpecific()

        await this.FetchFilteredData(this.initialFilters)
        if (this.$root.$data?.organization === 'spookynooksportsohio') {
          this.noResultUrl = 'https://www.spookynooksports.com/hamilton/email-sign-up'
        }
        this.initialDataLoaded = true
      }
    },
    async FetchFilteredData(queryToPush) {
      if (queryToPush) this.filtersQuery = queryToPush

      // Restructure query with filters id
      const query = {}

      for (let [key, param] of Object.entries(this.filtersQuery)) {
        if (Array.isArray(param)) {
          if (param.length) {
            query[key] = this.filtersQuery[key].map((i) => i.id)
          }
        } else if (param) query[key] = param
      }
      query.page = this.page
      query.sort = this.sort?.id
      query.organization = this.$root.$data?.organization

      // Push query to url
      this.$router.push({ query: query }).catch(() => {})

      // Fetch data
      this.showPreloader = true
      const [error, response] = await getFilteredCalendarData(this.baseUrl, query)

      if (error) console.log(error)
      else {
        this.count = response.count
        this.results = response.table
        this.total_pages = response.pager_info.total_pages
        this.showPreloader = false
      }
    },
    ParseQuery() {
      for (let [key, param] of Object.entries(this.$route.query)) {
        if (Array.isArray(param)) {
          // Parse array to multiple select.
          param.forEach((item) => {
            ;(this.initialFilters[key] || []).push(
              this.filtersOptions[key].find((option) => option.id === item)
            )
          })
        } else if (Array.isArray(this.filtersOptions[key]) && param) {
          // Parse single value to multiple select.
          // Waiting async prop filtersOptions from parent component
          if (this.filtersOptions[key].length)
            (this.initialFilters[key] || []).push(
              this.filtersOptions[key].find((option) => option.id === param)
            )
        } else if (param) this.initialFilters[key] = param
      }
      this.page = parseInt(this.$route.query.page) || 0
      delete this.initialFilters.page
      delete this.initialFilters.sort

      // Parse Sort filter
      const querySort = this.$route.query.sort
      if (querySort) {
        this.sort = this.sortOptions.find((item) => item.id === querySort)
      } else this.sort = this.sortOptions[4]
    },
    ParseProgramSpecific() {
      Object.keys(this.defaultFilters).forEach((key) => {
        if (this.$root.$data[key]) {
          if (!this.initialFilters[key].length)
            this.initialFilters[key].push({
              filter: `Preselected ${key}`,
              id: this.$root.$data[key]
            })

          this.defaultFilters[key].push({
            filter: `Preselected ${key}`,
            id: this.$root.$data[key]
          })
        }
      })
    },
    ResultsSortChange(sortBy) {
      this.sort = sortBy
      this.page = 0
      this.FetchFilteredData()
    },
    PageChanged(currentPage) {
      this.page = currentPage
      this.FetchFilteredData()
    },
    FilterChanged(filters) {
      this.page = 0
      this.filtersQuery = JSON.parse(JSON.stringify(filters))
      this.FetchFilteredData()
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Noto+Sans:wght@400;700&display=swap');

#spookynook-activenet-calendar-widget {
  font-family: $font-main;
  line-height: 1;
  color: $color-black;
  margin-bottom: 40px;

  h1,
  .h1,
  h2,
  .h2,
  h3,
  .h3,
  h4,
  .h4,
  h5,
  .h5 {
    font-family: $font-secondary !important;
    font-weight: normal;
  }

  h5,
  .h5 {
    font-size: rem(18);
    line-height: rem(21);

    @include media-breakpoint-up(lg) {
      font-size: rem(20);
      line-height: rem(24);
    }
  }
}
</style>
